function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import hasInterface from '../../../../hasInterface';
import Coordinate from '../geom/Coordinate';
import Orientation from './Orientation';
import CoordinateSequence from '../geom/CoordinateSequence';
var RayCrossingCounter = /*#__PURE__*/function () {
  function RayCrossingCounter() {
    _classCallCheck(this, RayCrossingCounter);
    RayCrossingCounter.constructor_.apply(this, arguments);
  }
  return _createClass(RayCrossingCounter, [{
    key: "countSegment",
    value: function countSegment(p1, p2) {
      if (p1.x < this._p.x && p2.x < this._p.x) return null;
      if (this._p.x === p2.x && this._p.y === p2.y) {
        this._isPointOnSegment = true;
        return null;
      }
      if (p1.y === this._p.y && p2.y === this._p.y) {
        var minx = p1.x;
        var maxx = p2.x;
        if (minx > maxx) {
          minx = p2.x;
          maxx = p1.x;
        }
        if (this._p.x >= minx && this._p.x <= maxx) {
          this._isPointOnSegment = true;
        }
        return null;
      }
      if (p1.y > this._p.y && p2.y <= this._p.y || p2.y > this._p.y && p1.y <= this._p.y) {
        var orient = Orientation.index(p1, p2, this._p);
        if (orient === Orientation.COLLINEAR) {
          this._isPointOnSegment = true;
          return null;
        }
        if (p2.y < p1.y) {
          orient = -orient;
        }
        if (orient === Orientation.LEFT) {
          this._crossingCount++;
        }
      }
    }
  }, {
    key: "isPointInPolygon",
    value: function isPointInPolygon() {
      return this.getLocation() !== Location.EXTERIOR;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      if (this._isPointOnSegment) return Location.BOUNDARY;
      if (this._crossingCount % 2 === 1) {
        return Location.INTERIOR;
      }
      return Location.EXTERIOR;
    }
  }, {
    key: "isOnSegment",
    value: function isOnSegment() {
      return this._isPointOnSegment;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RayCrossingCounter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "locatePointInRing",
    value: function locatePointInRing() {
      if (arguments[0] instanceof Coordinate && hasInterface(arguments[1], CoordinateSequence)) {
        var p = arguments[0];
        var ring = arguments[1];
        var counter = new RayCrossingCounter(p);
        var p1 = new Coordinate();
        var p2 = new Coordinate();
        for (var i = 1; i < ring.size(); i++) {
          ring.getCoordinate(i, p1);
          ring.getCoordinate(i - 1, p2);
          counter.countSegment(p1, p2);
          if (counter.isOnSegment()) return counter.getLocation();
        }
        return counter.getLocation();
      } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Array) {
        var _p = arguments[0];
        var _ring = arguments[1];
        var _counter = new RayCrossingCounter(_p);
        for (var _i = 1; _i < _ring.length; _i++) {
          var _p2 = _ring[_i];
          var _p3 = _ring[_i - 1];
          _counter.countSegment(_p2, _p3);
          if (_counter.isOnSegment()) return _counter.getLocation();
        }
        return _counter.getLocation();
      }
    }
  }]);
}();
export { RayCrossingCounter as default };
RayCrossingCounter.constructor_ = function () {
  this._p = null;
  this._crossingCount = 0;
  this._isPointOnSegment = false;
  var p = arguments[0];
  this._p = p;
};